<template>
  <div class="container mt-5 py-5">
    <!--Section: Content-->
    <section class="dark-grey-text mb-5 contact">
      <!-- Section heading -->
      <h3 class="font-weight-bold text-center mt-2 mb-4 image-fade-in">
        Demandez une démo de Livratos
      </h3>
      <!-- Section description -->
      <p class="text-center w-responsive mx-auto pb-5 image-fade-in">
        Vous gérez des <strong>dépôts matériaux</strong>, des
        <strong>équipes sur chantier</strong> ou une
        <strong>flotte de livreurs indépendants</strong>&nbsp;? Voyons ensemble
        comment Livratos peut simplifier vos
        <strong>livraisons express et programmées</strong> et réduire les
        allers-retours inutiles.
      </p>

      <!-- Grid row -->
      <div class="row contact__form">
        <!-- Grid column -->
        <div class="left-form col-lg-6 mb-lg-0 pb-lg-3 slide-left">
          <!-- Form with header -->
          <div class="card">
            <div class="card-body">
              <!-- Header -->
              <div class="form-header blue accent-1">
                <h3 class="mt-2">
                  <i class="fas fa-envelope"></i> Écrivez-nous
                </h3>
              </div>
              <p class="dark-grey-text">
                Posez vos questions sur Livratos, on vous répond rapidement,
                sans engagement.
              </p>
              <!-- Body -->
              <form ref="formData" @submit.prevent="sendEmail">
                <div class="md-form">
                  <i class="fas fa-user prefix grey-text"></i>
                  <label for="name">Nom</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    class="form-control"
                    maxlength="30"
                    required
                  />
                </div>
                <div class="md-form">
                  <i class="fas fa-envelope prefix grey-text"></i>
                  <label for="email">Email</label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    class="form-control"
                    required
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  />
                </div>
                <div class="md-form">
                  <i class="fas fa-phone prefix grey-text"></i>
                  <label for="phone">Téléphone</label>
                  <input
                    type="tel"
                    name="phone"
                    id="phone"
                    class="form-control"
                    required
                    pattern="^(\+?\d{1,3}[- ]?)?\d{10}$"
                  />
                </div>
                <div class="md-form">
                  <i class="fas fa-tag prefix grey-text"></i>
                  <label for="reason">Sujet</label>
                  <input
                    type="text"
                    placeholder="renseignements sur Livratos..."
                    name="reason"
                    id="reason"
                    class="form-control"
                    pattern="^[^/<>\n]*$"
                    required
                  />
                </div>
                <div class="md-form">
                  <i class="fas fa-pencil-alt prefix grey-text"></i>
                  <label for="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Décrivez votre activité et vos besoins logistiques"
                    class="form-control md-textarea"
                    rows="3"
                    pattern="^[^/<>\n]*$"
                    maxlength="450"
                    required
                  ></textarea>
                </div>
                <div class="text-center">
                  <span v-if="this.isCaptchaVisible">
                    <vue-hcaptcha
                      sitekey="cb1ebbbe-8022-4ff0-bd7a-e52cf64c7578"
                      @verify="onVerify"
                      @error="onError"
                    ></vue-hcaptcha>
                  </span>
                  <button name="contactBtn" class="btn btn-light-blue">
                    Envoyer
                  </button>
                </div>
              </form>
              <span v-if="this.modalConfirm">
                <ConfirmModal
                  @closeModalConfirm="closeModalConfirm"
                  title="Merci pour votre demande"
                  message="Nous vous recontactons rapidement pour parler de Livratos."
                  btnExit="À bientôt"
                />
              </span>
            </div>
          </div>
          <!-- Form with header -->
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="right-form col-lg-6 mb-lg-0 pb-lg-3">
          <!-- Form with header -->
          <div class="card slide-right">
            <div class="card-body">
              <!-- Header -->
              <div class="form-header blue accent-1">
                <h3 class="mt-2">
                  <i class="fas fa-calendar-alt"></i> Planifiez une démo
                </h3>
              </div>
              <p class="dark-grey-text">
                Réservez un créneau pour une démo Livratos&nbsp;: interface,
                <strong>livraisons express et programmées</strong>, questions
                techniques.
              </p>
              <!-- Body -->
              <div id="calendar" class="md-form">
                <CalendlyVue />
              </div>
            </div>
          </div>
          <!-- Form with header -->
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <div class="contact__info fall mt-2">
        <ContactCard />
        <SocialMedia />
      </div>

      <!-- Grid column -->
      <div class="col-lg-12">
        <h3 class="font-weight-bold text-center mt-4 mb-4">
          Livratos – Plateforme logistique BTP<br />
          Au service des dépôts, des <strong>chantiers</strong> et des
          <strong>livreurs</strong>
        </h3>

        <!--Google map-->
        <div
          id="map-container-section"
          class="z-depth-1-half map-container-section my-4"
          style="height: 400px"
        >
          <div style="width: 100%">
            <iframe
              loading="lazy"
              title="myFrame"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=fr&amp;q=Paris+(Livratos)&amp;t=k&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              width="100%"
              height="400"
              frameborder="0"
            ></iframe>
          </div>
        </div>

        <!-- Buttons / infos -->
      </div>
      <!-- Grid column -->
    </section>
    <!--Section: Content-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueHcaptcha from "@hcaptcha/vue3-hcaptcha";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";

import ContactCard from "@/components/partials/ContactCard.vue";
import SocialMedia from "@/components/partials/SocialMedia.vue";
import CalendlyVue from "@/components/plugins/CalendlyVue.vue";
export default {
  name: "contactForm",
  components: {
    ContactCard,
    SocialMedia,
    VueHcaptcha,
    ConfirmModal,
    CalendlyVue,
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
  data() {
    return {
      isCaptchaVerified: false,
      isCaptchaVisible: false,
      modalConfirm: false,
    };
  },
  computed: {
    ...mapGetters({
      SendingEmail: "StateSendingEmail",
      EmailSent: "StateEmailSent",
      EmailError: "StateEmailError",
    }),
  },
  methods: {
    ...mapActions(["SendContactEmail"]),
    sendEmail() {
      if (this.isCaptchaVerified) {
        this.SendContactEmail(this.$refs.formData);
        this.modalConfirm = true;
        this.isCaptchaVerified = false;
        this.isCaptchaVisible = false;
        this.$refs.formData.reset();
      } else {
        this.isCaptchaVisible = true;
      }
    },
    onVerify(token, eKey) {
      this.isCaptchaVerified = true;
      console.log("Verified: ", { token, eKey });
      console.log(this.isCaptchaVerified);
    },
    onError: (err) => {
      console.log("Error", err);
    },
    closeModalConfirm() {
      this.modalConfirm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  &__form {
    position: relative;
    align-items: stretch; // important pour que les col-lg-6 aient la même hauteur

    .left-form,
    .right-form {
      display: flex; // la colonne devient un conteneur flex
    }

    .left-form .card,
    .right-form .card {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .left-form {
      margin-bottom: 10px;

      .card {
        background: $color-primary;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 20px;

        h3 {
          color: $color-text-light;
        }
        p {
          color: $color-text-light;
        }
        .md-form {
          margin-top: 20px;
        }
      }

      i {
        color: #fff;
      }
      label {
        color: $color-secondary;
        margin-left: 10px;
      }
      button {
        border: 1px outset $color-secondary;
        color: $color-text-light;
        margin: 70px 0 20px;

        &:hover {
          border: 1px inset $color-text-light;
          background: $color-secondary;
          color: $color-primary;
        }
      }
    }

    .right-form {
      .card {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 20px;
        background: #000;
        margin-bottom: 10px;

        h3 {
          color: $color-primary;
        }
        p {
          color: $color-lighter;
        }
        .md-form {
          margin-top: 20px;
        }
      }

      i {
        color: #fff;
      }
      label {
        color: $color-darker;
      }
      button {
        border: 1px outset $color-text-light;
        color: $color-text;
        margin: 70px 0 20px;

        &:hover {
          border: 1px inset $color-text;
          background: $color-primary;
          color: $color-secondary;
        }
      }
    }
  }

  .follow {
    background: black;
    color: $color-primary;
    padding-top: 50px;

    span {
      color: $color-secondary;
    }
  }

  &__info {
    background: black;
    background: linear-gradient(to right, black 50%, #000000 50%);
    border-radius: 10px;
    display: flex;
    justify-content: space-around;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 20px;

    @media screen and (max-width: 992px) {
      flex-direction: column;
      align-items: center;
      background: linear-gradient(to bottom, black 56%, #000000 50%);
    }
  }
}

.map-container-section {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;

  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
}

.g-recaptcha {
  margin-bottom: 30px;
}

textarea {
  font-family: "Arial Black";
}

.slide-right.active {
  @include slide-right(1.2s);
}
.slide-left.active {
  @include slide-left(1.2s);
}
.fall.active {
  @include fall-down(1s);
}
</style>
